import React, { useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import useHttpRequests from "../../../hooks/useHttpRequests";
import * as utils from "../../common/utils";

const initialColumnLookupIsValid = {
  name: "",
};

export const ColumnLookupUpdate = (props) => {
  const {
    setUpdateOpen,
    columnLookupEdit,
    setColumnLookupEdit,
    columnLookupAttributes,
  } = props;

  const messageDispatch = useDispatch();
  const { sendRequest: updateColumnLookup } = useHttpRequests();

  const [columnLookupDetails, setColumnLookupDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    columnLookupAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialColumnLookupIsValid
  );

  const updateColumnLookupDetailsValue = (_key, value) => {
    setColumnLookupDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const onChangeHandler = (e, controlName) => {
    updateColumnLookupDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };

  const cancelColumnLookupHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setColumnLookupEdit(false);
    setUpdateOpen(false);
  };

  const validateColumnLookupDetails = () => {
    setIsValid(initialColumnLookupIsValid);

    var errorSummary = "";

    if (!columnLookupDetails.name) {
      updateErrorMessage("name", "Column Title", "Enter ");
      errorSummary += "Enter Column Title \n";
    } else if (!utils.isValidCharacters(columnLookupDetails.name)) {
      updateErrorMessage("name", "Column Title", " has restricted characters");
      errorSummary += "Column Title has restricted characters \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      const dataObj = columnLookupDetails;

      const getUpdateColumnLookupResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "Column updated successfully!",
          })
        );
        setTimeout(() => {
          cancelColumnLookupHandler();
        }, 2000);
      };

      if (columnLookupEdit) {
        updateColumnLookup(
          {
            url: "Columns/" + dataObj["columnKey"],
            method: "PUT",
            body: dataObj,
          },
          getUpdateColumnLookupResponse
        );
      } else {
        delete dataObj["columnKey"];
        updateColumnLookup(
          { url: "Columns", body: dataObj },
          getUpdateColumnLookupResponse
        );
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <MessageDisplay />
          <InputText
            type="text"
            label="Column Title"
            id={"columnLookupDetails.name"}
            value={columnLookupDetails.name}
            onChange={(e) => onChangeHandler(e, "name")}
            isRequired={true}
            isError={isValid["name"] !== ""}
            charLength={50}
          />
          <SaveCancel
            cancelCall={() => cancelColumnLookupHandler()}
            saveCall={() => validateColumnLookupDetails()}
          />
        </div>
      </Box>
    </>
  );
};
